"use client"

import {useEffect} from "react";

export default function ProfitWellIntegration() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !window.profitwellScriptLoaded) {
      // Create the auth script tag first
      const authScript = document.createElement('script');
      authScript.id = 'profitwell-js';
      authScript.setAttribute('data-pw-auth', process.env.NEXT_PUBLIC_PROFITWELL_ID ?? "");
      document.body.appendChild(authScript);

      // Load the ProfitWell script
      (function (i, s, o, g, r, a, m) {
        i[o] = i[o] || function () {
          (i[o].q = i[o].q || []).push(arguments);
        };
        // @ts-ignore
        a = s.createElement(g);
        // @ts-ignore
        m = s.getElementsByTagName(g)[0];
        // @ts-ignore
        a.async = 1;
        // @ts-ignore
        a.src = r + '?auth=' + s.getElementById(o + '-js').getAttribute('data-pw-auth');
        // @ts-ignore
        m.parentNode.insertBefore(a, m);
      })(window, document, 'profitwell', 'script', 'https://public.profitwell.com/js/profitwell.js');

      window.profitwellScriptLoaded = true;
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.profitwell) {
      window.profitwellFired = true;
      window.profitwell('start', {})
    }
  }, []);

  return null;
};